import { render, staticRenderFns } from "./AccountVerificationEmailSentProvider.vue?vue&type=template&id=1a5247f6&"
import script from "./AccountVerificationEmailSentProvider.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationEmailSentProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports